import { format } from "date-fns";

export const getFormattedDeletionDate = (
    deletionDate?: string,
): string | null => {
    if (!deletionDate) {
        return "";
    }

    return format(new Date(deletionDate), "dd-MM-yyyy");
};
